'use client'
import React, { useCallback, useEffect, useState } from 'react'
import type { LocationPillsItemProps } from './LocationPills'
import LocationPills from './LocationPills'
import { getLocationManager } from '@/services/location/LocationManagerInstance'
import { getTrackingService } from '@/services/tracking/TrackingInstance'
import { fetchCurrentConditions } from '@/services/api/bff/weather/Weather.service'
import { Location } from '@/services/location/types'
import { notifyError } from '@/lib/bugsnag/client'

const LocationPillsState: React.FC<any> = () => {
  const locationManager = getLocationManager()
  const trackingService = getTrackingService()
  const [items, setItems] = useState<LocationPillsItemProps[]>([])

  const createLocationData = useCallback(async (loc: Location) => {
    let currentConditions = loc.fetchedCurrentConditions
    try {
      const currentConditionsResponse = await fetchCurrentConditions(
        loc.geohash,
      )
      currentConditions = currentConditionsResponse.data
    } catch (e: any) {
      notifyError(
        `Unable to fetch current conditions of location '${loc.geohash}'`,
        {
          component: 'LocationPill.state',
          message: e.message,
          cause: e.cause,
          stack: e.stack,
        },
      )
    }

    return {
      city: loc.name,
      symbol: currentConditions?.attributes?.weatherSymbol ?? '1',
      degrees: currentConditions?.attributes?.temperature ?? 0,
      url: loc.url,
    }
  }, [])

  const refresh = useCallback(() => {
    const topFive = locationManager.getTopFiveLocations()
    Promise.all(topFive.map(createLocationData)).then((results) =>
      setItems(results),
    )
  }, [locationManager])

  useEffect(() => {
    refresh()
    return locationManager.subscribe(refresh)
  }, [locationManager, refresh])

  const handleClick = (url: string) => {
    trackingService.addAndExecuteCommand('navigation-clicked', {
      navigation_path: url,
    })
    window.location.href = url
  }

  return <LocationPills items={items} onClick={handleClick} />
}

export default LocationPillsState
